import {Modal} from "../utils/Modal";
import {DOM} from "../utils/DOM";

export namespace CustomLoader {

    export class UiHandler {

        /**
         * Is modal shown -> show progress in modal
         * Not modal shown -> hide default progress
         */
        public static showLoader = () : void => {

            const shownModal = Modal.Helpers.getShownModal();
            if (shownModal !== null) {
                DOM.Parser.getHtmlElementByClass('modal-progress', shownModal).style.display = 'block';
            } else if (document.getElementById('loader')) {
                DOM.Parser.getHtmlElement('loader').style.display = 'block';
            }
        };

        /**
         * Hide all modal progress
         * Hide default loader
         */
        public static hideLoader = () : void => {

            const modalProgressElements = DOM.Parser.getHtmlElements('modal-progress', undefined, true);
            for (let i = 0; i < modalProgressElements.length; i++) {
                modalProgressElements[i].style.display = 'none';
            }

            if (document.getElementById('loader') !== null) {
                DOM.Parser.getHtmlElement('loader').style.display = 'none';
            }
        };
    }
}
